import type { AxiosResponse } from "axios";
import { AxiosError } from "axios";

const convert = <T>(response: (AxiosResponse<T> & { errorCode?: string }) | null | undefined): T => {
	try {
		if (!response || typeof response.data === "undefined" || response?.errorCode === AxiosError.ERR_CANCELED) {
			console.error("Invalid AxiosResponse:", response);
			if (response?.errorCode === AxiosError.ERR_CANCELED) {
				throw new Error("Invalid AxiosResponse", {
					cause: response.errorCode
				});
			}
			throw new Error("Invalid AxiosResponse");
		}
		return response.data as T;
	} catch (err: any) {
		console.log("Error in convert function", err);
		throw new Error(err?.message || "Error in convert function", {
			cause: err?.cause
		});
	}
};

const ConvertCount = ({ data }: AxiosResponse): number => data && parseInt(data.count, 10);

export default { convert, ConvertCount };
